import styled from "styled-components";

const FoooterWrapper = styled.footer`
  min-width: 1200px;
  width: 100%;
  height: 120px;
  background-color: #0f0f0f;
  box-sizing: border-box;

  & > div {
    width: 1200px;
    margin: 0 auto;
    padding: 48px 20px 0px 20px;
    box-sizing: border-box;
  }

  & > div > p {
    text-align: left;
    font-size: 13px;
    color: #cccccc;
  }

  & > div > p:first-child {
    margin-bottom: 8px;
  }

  @media (max-width: 426px) {
    min-width: 100%;
    box-sizing: border-box;

    & > div {
      width: 100%;
      margin: 0 auto;
    }

    & > div > p {
      font-size: 12px;
    }
  }
`;

function Footer() {
  return (
    <FoooterWrapper>
      <div>
        <p>(주) 킹메이커스</p>
        <p>각종문의 : devtiger.academy@gmail.com</p>
      </div>
    </FoooterWrapper>
  );
}

export default Footer;
